import React from "react"
import { graphql } from "gatsby"
import { useTranslation } from "react-i18next"
import SeoLandingPage from "../../../components/SeoLandingPage"
import { NiepolomicePlotsContent } from "../../../components/SeoLandingPage/NiepolomiceContent"
import { InlineLink, SeeAlso } from "../../../components/SeoLandingPage/style"
import { GMINA_NIEPOLOMICE } from "../../../constants/offerLocations"

const NiepolomicePlotsPage: React.FC = () => {
  const { t } = useTranslation("index", {
    keyPrefix: "pages.properties-niepolomice-plots",
  })

  const faq = [1, 2, 3, 4, 5].map(index => ({
    question: t(`faq.question-${index}.title`),
    answer: t(`faq.question-${index}.answer`),
  }))

  return (
    <SeoLandingPage
      seoTitle={t("seo.title")}
      seoDescription={t("seo.description")}
      h1={t("h1")}
      headerVariant="niepolomice"
      breadcrumbs={[
        { label: t("breadcrumbHome"), to: "/" },
        { label: t("breadcrumbProperties"), to: "/nieruchomosci/" },
        { label: t("breadcrumbNiepolomice"), to: "/nieruchomosci/niepolomice/" },
        { label: t("breadcrumb"), to: "/nieruchomosci/niepolomice/dzialki/" },
      ]}
      faq={faq}
      cities={GMINA_NIEPOLOMICE}
      propertyType="land"
      transaction="sell"
      offersTitle={t("offersTitle")}
      emptyOffersMessage={t("emptyOffersMessage")}
      seeAlso={[
        {
          prefix: t("seeAlsoPrefix"),
          label: t("seeAlsoLabel"),
          to: "/nieruchomosci/niepolomice/domy/",
        },
      ]}
      extraSeeAlso={
        <SeeAlso>
          {t("officePrefix")}{" "}
          <InlineLink to="/kontakt/niepolomice/">{t("officeLink")}</InlineLink>
        </SeeAlso>
      }
    >
      <NiepolomicePlotsContent />
    </SeoLandingPage>
  )
}

export default NiepolomicePlotsPage

export const query = graphql`
  query {
    locales: allLocale {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
